import {
  clearClickListeners,
  clearCorrectAnswers,
  findAndUncheckCorrectAnswer,
  initAnswerHandler,
  setupQuizQuestion,
} from 'helpers/Question'
import { stepInit } from 'helpers/Step'
import { renderMakecodeBlocks } from 'helpers/makecode'
import { scratchblocksInit } from 'helpers/scratchblocks'
import find from 'lodash/find'
import some from 'lodash/some'
import PropTypes from 'prop-types'
import { Wysiwyg } from 'raspberry-pi-bits'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { translate } from 'react-i18next'

import './Question.css'

export const Question = (props) => {
  const {
    content,
    answers,
    t,
    currentQuestion,
    answerQuestion,
    nextQuestion,
    quizLength,
    project,
    locale,
  } = props

  const [answerInit, setAnswerInit] = useState(false)
  const elementRef = useRef()

  const getOrderAndAnswerStatus = useCallback(
    (answer) => {
      const currentAnswers = answers[currentQuestion + 1] || []
      const answered = some(currentAnswers, ['result', 'correct'])
      if (find(currentAnswers, { answer })) {
        return [-1, answered]
      }

      return [currentAnswers.length, answered]
    },
    [answers, currentQuestion]
  )

  const checkLast = useCallback(() => {
    return currentQuestion + 1 === quizLength
  }, [currentQuestion, quizLength])

  useEffect(() => {
    const resultHandler = (data) => {
      answerQuestion(data)
    }

    if (answerInit) {
      initAnswerHandler(
        elementRef.current,
        getOrderAndAnswerStatus,
        checkLast,
        resultHandler,
        nextQuestion,
        t
      )
      setAnswerInit(false)
    }
  }, [
    answerQuestion,
    getOrderAndAnswerStatus,
    checkLast,
    nextQuestion,
    answers,
    t,
    answerInit,
  ])

  useEffect(() => {
    findAndUncheckCorrectAnswer(elementRef.current)
    return () => {
      clearClickListeners()
      clearCorrectAnswers()
    }
  }, [content])

  useEffect(() => {
    setupQuizQuestion(elementRef.current, t)
    stepInit()
    setAnswerInit(true)
  }, [nextQuestion, t])

  useEffect(() => {
    scratchblocksInit(project, locale)
    renderMakecodeBlocks()
  })

  useEffect(() => {
    const animate =
      window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === false
    const behavior = animate ? 'smooth' : 'auto'
    elementRef.current.scrollIntoView({
      behavior,
      block: 'start',
      inline: 'nearest',
    })
  }, [content])

  return (
    <div className="c-project-steps__wrapper knowledge-quiz-question__wrapper">
      <Wysiwyg>
        {content.length > 0 && (
          <div
            ref={elementRef}
            className="c-project-steps__content"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        )}
      </Wysiwyg>
    </div>
  )
}

Question.propTypes = {
  content: PropTypes.string.isRequired,
  answers: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  currentQuestion: PropTypes.number.isRequired,
  answerQuestion: PropTypes.func.isRequired,
  nextQuestion: PropTypes.func.isRequired,
  quizLength: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
}

export default translate('translations')(Question)
